module.exports = __webpack_public_path__ + "img/milelogix_howto.d5c632dd.png";